const { Modal } = require("bootstrap");

$(function () {
    window.show_modal = function (modalId) {
        const modal = new Modal($(`#${modalId}`)[0]);
        modal.show();
        $(`#${modalId}`)
            .find('button[data-bs-dismiss="modal"]')
            .on("click", () => {
                modal.hide();
            });
    };
});
